/* eslint-disable arrow-body-style */
import React from 'react';
// @ts-ignore
import { List as VirtualizedList, AutoSizer } from 'react-virtualized';
import ChartCardItem from '@/pages/datalab/pages/WorkBench/components/RightModal/ChartCardItem';
import { useMemoizedFn } from 'ahooks';
import { chartListItemType } from '@/pages/datalab/pages/WorkBench/CreateReport/_type';
import '../index.scss';

const ROW_HEIGHT = 116;

interface IRightChartListProps {
  className?: string;
  handleDragStart: (item: chartListItemType) => void;
  chartList: chartListItemType[];
  hasMore: boolean;
  loadMore: () => void;
}

const RightChartList = (props: IRightChartListProps) => {
  const {
    className = '',
    handleDragStart,
    chartList = [],
    hasMore,
    loadMore,
  } = props;

  const handleRowsRendered = useMemoizedFn(({ stopIndex }: { stopIndex: number; }) => {
    if (!hasMore) return;
    if (chartList.length === 0) return;
    if (stopIndex >= chartList.length - 1) {
      loadMore();
    }
  });

  return (
    <div className={`dbl-charts-module-context ${className}`}>
      <AutoSizer>
        {({ width, height }: any) => {
          return (
            <VirtualizedList
              rowCount={chartList.length}
              rowRenderer={({ index, style }: any) => {
                const item = chartList[index];
                return (
                  <div style={style}>
                    <ChartCardItem data={item} handleDragStart={handleDragStart} />
                    {/* 占位div */}
                    <div className="dbl-new-dashboard-right-chart-tab-item"></div>
                  </div>
                );
              }}
              width={width}
              height={height + 20}
              rowHeight={ROW_HEIGHT}
              overscanRowCount={5}
              onRowsRendered={handleRowsRendered}
            />
          );
        }}
      </AutoSizer>
    </div>
  );
};

export default RightChartList;
